import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import tw from "tailwind-styled-components";
const Container = tw.div`
  ${({ $direction, $justify, $align, $gap, $gapX, $gapY, $wrap, $grow, $margin, $width, $height })=>{
    /**
     * Check if gap value ends in a number. If id does
     * use the value as is. If not then we need to wrap
     * the value in brackets to match the tailwind arbitrary
     * value api.
     */ const gapValue = !$gap ? undefined : /[0-9]+$/.test($gap) ? $gap : `[${$gap}]`;
    const grow = !$grow ? "[0]" : `[${$grow}]`;
    return `
      relative
      flex
      flex-${$direction}
      justify-${$justify}
      ${!!$align ? `items-${$align}` : ""}
      gap-${gapValue}
      ${$gapX}
      ${$gapY}
      flex-${$wrap}
      ${!$grow ? "grow-0" : $grow === "1" ? "grow" : `grow-${grow}`}
      ${$margin}
      ${$width ? `${$width}` : ""}
      ${$height ? `${$height}` : ""}
    `;
}}
`;
const SFlex = ({ children, direction = "row", justify = "start", align, gap = "0", gapX, gapY, wrap = "nowrap", grow, margin, width, height })=>{
    return /*#__PURE__*/ _jsx(Container, {
        $direction: direction,
        $justify: justify,
        $align: align,
        $gap: gap,
        $gapX: gapX,
        $gapY: gapY,
        $wrap: wrap,
        $grow: grow,
        $margin: margin,
        $width: width,
        $height: height,
        children: children
    });
};
export { SFlex };
